module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('big', [_vm._v("B")]), _vm._v("reakfast, or the concept of a “proper breakfast,” can be unpredictable. I like it that way. When I feel inspired, I like rummaging around the pantry and refrigerator for unexpected muffin, scone, or pancake ingredients. I might use up some fresh fruit, chop some chocolate, stir in a bit of brandy, or break apart a stale baguette. When I am feeling less ambitious, I might just reheat leftover macaroni and cheese, or grab a bagel from the local deli, or both. I leave myself open to either option—I consider myself a breakfast optimist, and I never plan in advance.")], 1), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s not that I am blasé about breakfast. Actually, I am quite a breakfast advocate; I just never structure the meal like I might a lunch for friends or a large dinner party. I have never “dressed” for breakfast (a frightening idea!), and I don’t enjoy the idea of sitting formally at a table in the morning. I prefer to fly solo for my first meal of the day, and most likely I am hunched over the morning news, be it on my laptop or the daily paper.")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Generously spray the inside of a 10-inch Bundt pan with nonstick cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a small saucepan, warm your milk to slightly above room temperature, then remove it from the heat, add the yeast, and whisk to dissolve. (Do not warm it beyond 110 degrees F or you will kill the yeast).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the bowl of a standing mixer fitted with the paddle attachment, beat the flour, sugar, and salt until combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a small bowl, beat the egg with a fork and add it to the dry ingredients. Mix on low speed until combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Keeping the mixer on low, slowly stream in the milk until combined. Add the melted butter and mix until the dough comes together. Replace the paddle attachment with the dough hook attachment. Continue to mix on medium speed until the dough becomes silky and tacky, but not sticky, 8 to 10 minutes. The dough should mound together and easily come off the bottom of the mixing bowl. (If the dough is too wet, add some flour. If it is too dry, add a tiny bit of water.)")]), _vm._v(" "), _vm._m(38), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Line a sheet pan with parchment paper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Use your clean hands to push down and deflate the dough. Remove it from the bowl and pat it into a rough circle approximately 8 inches diameter. Use a bench knife or serrated knife to cut dough into 1- to 1½-inch pieces (about ½ ounce each)—alternatively, use your hands to pinch apart the dough. Roll the pieces into balls (they don’t have to be perfectly round). Place the balls on the sheet pan (you will get about 60 pieces in all). Cover the balls lightly with plastic wrap.")]), _vm._v(" "), _vm._m(39), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a small bowl, stir together the sugar and cinnamon. Place the melted butter in a separate bowl.")]), _vm._v(" "), _vm._m(40), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Remove the plastic wrap from the dough balls and dip one ball in the melted butter. Let the excess butter drip back into the bowl, roll the ball in the brown sugar mixture, and place it in the Bundt pan. Continue this process with each ball, until you have several layers, arranging them as if you are building a brick wall.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Wrap the Bundt pan tightly in plastic wrap. Set it in a warm area of the house for about 1 hour, or until the dough balls have doubled in size and appear puffy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 350 degrees F. Remove the plastic and bake the Bundt until the top layer is deep brown and the caramel coating begins to bubble around the edges, about 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cool the bread for 5 minutes, then turn it out directly onto a platter and serve warm. Should you have any leftovers (this is rare, I promise you), simply reheat them in a 300-degree oven until warm to the touch.")]), _vm._v(" "), _vm._m(41), _vm._v(" "), _c('p', {
    staticClass: "bakedtext"
  }, [_vm._v("There are a lot of monkey bread misconceptions, and I will do my darnedest to dispel them. First, you do not need an icing or topping for this bread—too sweet. Second, you can make the dough ahead of time. Once the dipped dough has been placed in the pan, wrap it tightly, refrigerate it, and bring it back to room temperature to proof the dough before baking. Lastly, this is one of those breads that exists to be eaten warm, straight from the oven. Once the caramel begins to cool, reheat the bread in the oven before serving.")]), _vm._v(" "), _vm._m(42), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _vm._m(59), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 400 degrees F. Lightly spray each cup of a standard 12-cup muffin pan with a little bit of vegetable spray and use a paper towel to spread the oil evenly along the bottom and up the sides of each cup.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large bowl, whisk together the pumpkin and sour cream. Add the eggs and butter and whisk until combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In another large bowl, whisk together the flour, baking powder, cayenne pepper, salt, black pepper, and brown sugar. Make a well in the middle of the dry ingredients. Pour the wet ingredients into the well, and fold until just combined. Fold in three-quarters of the cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Divide the batter among the muffin cups. Sprinkle the remaining cheddar and the pumpkin seeds on top of the muffins. Bake them for 20 minutes, or until golden brown. Let the muffin pan cool on a rack for 10 minutes before turning out the muffins. Serve them warm.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Muffins taste best when eaten fresh, but they can be made ahead of time and reheated in a 200-degree oven.")]), _vm._v(" "), _vm._m(62), _vm._v(" "), _c('p', {
    staticClass: "bakedtext"
  }, [_vm._v("I am addicted to the raw-milk cheddar offered by several farms in Vermont. The flavors are more dimensional than ordinary cheddar (though, yes, I am still a fan of the pasteurized version); raw-milk cheeses are nutty and chocolatey and earthy—and different from farm to farm. This recipe works well with any cheddar, the sharper the better, but make sure you try a raw-milk one if the opportunity presents itself (in or out of this muffin recipe).")]), _vm._v(" "), _vm._m(63), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _vm._m(64), _vm._v(" "), _vm._m(65), _vm._v(" "), _vm._m(66), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Farm stand doughnuts are usually sold coated with cinnamon sugar and tucked inside a paper bag. Sometimes they are made with cider, and sometimes they are made with buttermilk, and they are always worth stopping for. I prefer the buttermilk variety (it produces a cakier doughnut), and I prefer mine dipped in chocolate, but they taste great au naturel as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each topping makes enough for one batch of doughnuts. If you want to use more than one topping for your batch, reduce the amounts by half or by two-thirds, accordingly.")]), _vm._v(" "), _vm._m(67), _vm._v(" "), _vm._m(68), _vm._v(" "), _vm._m(69), _vm._v(" "), _vm._m(70), _vm._v(" "), _vm._m(71), _vm._v(" "), _vm._m(72), _vm._v(" "), _vm._m(73), _vm._v(" "), _vm._m(74), _vm._v(" "), _vm._m(75), _vm._v(" "), _vm._m(76), _vm._v(" "), _vm._m(77), _vm._v(" "), _vm._m(78), _vm._v(" "), _vm._m(79), _vm._v(" "), _vm._m(80), _vm._v(" "), _vm._m(81), _vm._v(" "), _vm._m(82), _vm._v(" "), _vm._m(83), _vm._v(" "), _vm._m(84), _vm._v(" "), _vm._m(85), _vm._v(" "), _vm._m(86), _vm._v(" "), _vm._m(87), _vm._v(" "), _vm._m(88), _vm._v(" "), _vm._m(89), _vm._v(" "), _vm._m(90), _vm._v(" "), _vm._m(91), _vm._v(" "), _vm._m(92), _vm._v(" "), _vm._m(93), _vm._v(" "), _vm._m(94), _vm._v(" "), _vm._m(95), _vm._v(" "), _vm._m(96), _vm._v(" "), _vm._m(97), _vm._v(" "), _vm._m(98), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Line one baking sheet with parchment paper and another baking sheet with two layers of paper towels.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large bowl, whisk together the flour, sugar, baking soda, baking powder, salt, nutmeg, and cinnamon.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a medium bowl, whisk the eggs, buttermilk, and sour cream until combined. Add the melted, cooled butter and whisk again.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Make a well in the center of the flour mixture and pour the liquid ingredients into the well. With a rubber spatula, slowly fold the flour into the liquid center until the mixture forms a sticky dough.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Turn the dough out onto a work surface lightly dusted with flour. Sprinkle the top of the dough with flour and pat it out until it is about ½ inch thick.")]), _vm._v(" "), _vm._m(99), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour enough oil into a deep skillet to make a layer approximately 1 inch to 1½ inches deep. Slowly heat the oil over medium-high heat until it is 365 to 370 degrees F.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("While you are waiting for the oil to reach temperature, make the assorted toppings.")]), _vm._v(" "), _vm._m(100), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place the chopped chocolate in a medium wide-mouthed bowl. In a small saucepan, heat the cream until it is just about to boil. Pour the cream over the chocolate and wait 1 minute. Whisk until smooth. Whisk in the butter. Keep the mixture warm.")]), _vm._v(" "), _vm._m(101), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a medium wide-mouthed bowl, whisk together the sugar, the milk, and the vanilla paste.")]), _vm._v(" "), _vm._m(102), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a medium wide-mouthed bowl, whisk together the sugar and cinnamon.")]), _vm._v(" "), _vm._m(103), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Once the oil reaches temperature, gently lift the large doughnuts off the baking sheet and place them in the hot oil. Do not crowd the skillet—make no more than 3 doughnuts at a time. Once they have browned on one side (this takes 2 to 3 minutes), turn them over with tongs or a slotted spoon and continue to cook for another minute or just until browned (they can overcook or burn rather quickly). Using a slotted spoon, transfer the doughnuts to the paper towel–lined baking sheet and continue to fry the rest of the dough until finished. The doughnut holes will cook faster and can be made in two or three batches after the doughnuts are done.")]), _vm._v(" "), _vm._m(104), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Once you have finished frying, work quickly to dip the doughnuts in the chocolate or vanilla glaze, or the cinnamon sugar. If you like, decorate the chocolate or vanilla doughnuts with sprinkles. Serve immediately.")]), _vm._v(" "), _vm._m(105), _vm._v(" "), _c('p', {
    staticClass: "bakedtext"
  }, [_vm._v("When you fry the doughnuts, make sure you maintain the correct oil temperature throughout the process. Generally speaking, doughnuts taste best served immediately after they’ve emerged from the fryer (and taken a quick dip in sugar or chocolate or vanilla); however, I have managed to find a few uses that play to the strengths of leftover (or day-old) doughnuts. Chop them into big coarse crumbs, toast them lightly, and add them to vanilla ice cream as a mix-in (if you are making it from scratch) or a topping (if you are serving store-bought). Doughnuts also work wonders (very rich wonders) when aused as the base of a bread pudding.")]), _vm._v(" "), _vm._m(106), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _vm._m(107), _vm._v(" "), _vm._m(108), _vm._v(" "), _vm._m(109), _vm._v(" "), _vm._m(110), _vm._v(" "), _vm._m(111), _vm._v(" "), _vm._m(112), _vm._v(" "), _vm._m(113), _vm._v(" "), _vm._m(114), _vm._v(" "), _vm._m(115), _vm._v(" "), _vm._m(116), _vm._v(" "), _vm._m(117), _vm._v(" "), _vm._m(118), _vm._v(" "), _vm._m(119), _vm._v(" "), _vm._m(120), _vm._v(" "), _vm._m(121), _vm._v(" "), _vm._m(122), _vm._v(" "), _vm._m(123), _vm._v(" "), _vm._m(124), _vm._v(" "), _vm._m(125), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 375 degrees F and place the rack in the center. Line a baking sheet with parchment paper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large bowl, whisk the flour, sugar, cocoa powder, baking powder, and salt until combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Add the butter. Use your fingertips to rub it into the flour until the butter is pea size and the mixture is coarse.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a separate bowl, whisk together the egg and cream. Slowly pour the wet ingredients into the dry ingredients and stir until the dough just comes together. Gently and briefly knead the dough with your hands. Add the toasted hazelnuts and knead gently to incorporate. Flatten the dough into a rectangle approximately 6 by 12 inches (it does not need to be precise) and spread ¼ cup of the Nutella on top in a crisscross pattern. Roll the dough up to make a cylinder about 6 inches long, turn it on its end, and gently flatten it into a disk about 1¾ inches high. Do not overwork the dough.")]), _vm._v(" "), _vm._m(126), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Transfer the scones to a wire rack to cool completely. Place the baking sheet with the parchment still on it underneath the rack.")]), _vm._v(" "), _vm._m(127), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Heat the remaining ¼ cup Nutella in a microwave until pourable, about 10 seconds on high. Pierce the tops of the scones a few times with a fork. Use a spoon (or two spoons—one to scoop, one to scrape) to drip the warm Nutella in a zigzag pattern over the tops of the hot scones. Transfer them to a refrigerator to set for 5 minutes, then serve immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Most scones have a lifespan of 24 hours or less; however, these scones taste pretty darn good on day two provided you wrap them tightly and store them at room temperature.")]), _vm._v(" "), _vm._m(128), _vm._v(" "), _c('p', {
    staticClass: "bakedtext"
  }, [_vm._v("My number-one piece of advice for those new to scone making: Do not knead too much. I think we must be born with an urge to create perfect, smooth, pliable, pillowy dough. Resist the temptation. Stop working the dough the minute it comes together. Do not worry if there are a few dry bits scattered throughout.")]), _vm._v(" "), _vm._m(129), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _vm._m(130), _vm._v(" "), _vm._m(131), _vm._v(" "), _vm._m(132), _vm._v(" "), _vm._m(133), _vm._v(" "), _vm._m(134), _vm._v(" "), _vm._m(135), _vm._v(" "), _vm._m(136), _vm._v(" "), _vm._m(137), _vm._v(" "), _vm._m(138), _vm._v(" "), _vm._m(139), _vm._v(" "), _vm._m(140), _vm._v(" "), _vm._m(141), _vm._v(" "), _vm._m(142), _vm._v(" "), _vm._m(143), _vm._v(" "), _vm._m(144), _vm._v(" "), _vm._m(145), _vm._v(" "), _vm._m(146), _vm._v(" "), _vm._m(147), _vm._v(" "), _vm._m(148), _vm._v(" "), _vm._m(149), _vm._v(" "), _vm._m(150), _vm._v(" "), _vm._m(151), _vm._v(" "), _vm._m(152), _vm._v(" "), _vm._m(153), _vm._v(" "), _vm._m(154), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 400 degrees F and position the rack in the center. Line a baking sheet with parchment paper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large bowl, whisk together the flour, sugar, oats, baking powder, salt, and shredded sweetened coconut.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Add the butter. Use your fingertips to rub the butter into the flour until the butter is pea size and the mixture is coarse.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a separate bowl, whisk together the egg, buttermilk, vanilla and carrot puree. Slowly pour the wet ingredients into the dry ingredients and stir until the dough just comes together. Gently and briefly knead the dough with your hands. The dough will be sticky and may need to be sprinkled with flour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Roll the dough up, turn it on its end, and gently flatten it into a disk about 1¾ inches high. Do not overwork the dough.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whisk the egg white with 1 tablespoon water. Set aside.")]), _vm._v(" "), _vm._m(155), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Transfer the scones to a wire rack to cool completely. Place the baking sheet, with the parchment still on it, underneath the rack.")]), _vm._v(" "), _vm._m(156), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whisk all ingredients together in a medium bowl. The glaze should be loose enough to drizzle. If it is too thick, add a little more orange juice. If it is too loose, add a little more confectioners’ sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Drizzle the glaze over the scones and allow it to set before serving.")]), _vm._v(" "), _vm._m(157), _vm._v(" "), _c('p', {
    staticClass: "bakedtext"
  }, [_vm._v("I can assume that if you are attempting this recipe, you are not expecting a classic English scone. I feel obliged to tell everyone that this is more of a “morning cookie” with a scone ego. Make no mistake —this scone is less sweet than a typical cookie, and the oats and carrot lend an air of nutrition, but deep down this is a perfect treat for morning, noon, and night. Queen Elizabeth might scoff, but no one else will.")]), _vm._v(" "), _vm._m(158), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(159), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Truthfully, I prefer carrots in the “puree” form. I prefer carrot soup to carrot sticks and a carrot–mashed potato concoction to a side of steamed carrots. I use this puree in various recipes (cakes, pancakes, lasagna, and soup), and it is quick, easy, and perfect for our Carrot Coconut Scones. Double it, triple it, and freeze for later use.")]), _vm._v(" "), _vm._m(160), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place the carrot and orange juice in a medium glass microwaveable bowl. Cover or wrap tightly in plastic wrap.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Microwave on high for about 5 minutes. If the carrot is fork-tender, it is ready. If it is not fork-tender, continue to microwave in 30-second bursts until it is.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Blend (in blender or food processer) the carrot and the orange juice until smooth or, alternatively, mash with a potato masher until lump free.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _vm._m(161), _vm._v(" "), _vm._m(162), _vm._v(" "), _vm._m(163), _vm._v(" "), _vm._m(164), _vm._v(" "), _vm._m(165), _vm._v(" "), _vm._m(166), _vm._v(" "), _vm._m(167), _vm._v(" "), _vm._m(168), _vm._v(" "), _vm._m(169), _vm._v(" "), _vm._m(170), _vm._v(" "), _vm._m(171), _vm._v(" "), _vm._m(172), _vm._v(" "), _vm._m(173), _vm._v(" "), _vm._m(174), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Lightly butter the bottom and sides of a 10-inch cast-iron skillet or, alternatively, a similar size baking dish.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour the milk and 2 cups water into a medium saucepan, cover, and heat on medium-high until the mixture boils, about 5 minutes. Uncover the pot, add the grits, salt, and pepper, and reduce the heat to medium. Stir constantly until grits are the consistency of thick soup, about 8 minutes. Reduce to a simmer, stirring every 2 minutes, and cook for about 15 to 20 minutes to let the grits thicken further. Cook for 10 to 15 minutes longer, stirring constantly to prevent the grits from sticking to the bottom of the pan. The grits will be really thick at this point.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Remove the pan from the heat and stir in ¾ cup of the cheddar cheese, ¾ cup of the Monterey Jack cheese, and the butter. Pour the grits into the prepared skillet and top them with the remaining cheeses. Turn the oven to broil.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place the skillet directly under the heating element for 2 to 3 minutes, or until the cheese topping is melted and starts to brown. Serve immediately.")]), _vm._v(" "), _vm._m(175), _vm._v(" "), _c('p', {
    staticClass: "bakedtext"
  }, [_vm._v("What is the difference between stoneground and instant grits? Well, technically, instant grits are grits with the germ (i.e., the healthy part) removed. Tastewise, I liken instant grits to instant mashed potatoes: flavorless, manufactured, and without depth. I may be terribly lazy in the kitchen, and you won’t find me making my own peanut butter anytime soon, but I beg of you, always use stone-ground grits.")]), _vm._v(" "), _vm._m(176), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _vm._m(177), _vm._v(" "), _vm._m(178), _vm._v(" "), _vm._m(179), _vm._v(" "), _vm._m(180), _vm._v(" "), _vm._m(181), _vm._v(" "), _vm._m(182), _vm._v(" "), _vm._m(183), _vm._v(" "), _vm._m(184), _vm._v(" "), _vm._m(185), _vm._v(" "), _vm._m(186), _vm._v(" "), _vm._m(187), _vm._v(" "), _vm._m(188), _vm._v(" "), _vm._m(189), _vm._v(" "), _vm._m(190), _vm._v(" "), _vm._m(191), _vm._v(" "), _vm._m(192), _vm._v(" "), _vm._m(193), _vm._v(" "), _vm._m(194), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 350 degrees F. Generously spray the inside of a 10-inch Bundt pan with nonstick cooking spray; alternatively, butter it well, dust it with flour, and knock out the excess flour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large bowl, whisk together the flour, baking powder, and salt. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the bowl of a standing mixer fitted with the paddle attachment, beat the egg yolks until they are pale and light; slowly pour in the sugar until it is completely incorporated. Add the yogurt and olive oil and mix until thoroughly combined. Add the orange zest and vanilla, and mix until just incorporated.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Add the flour mixture to the wet ingredients in two parts, beating after each addition until just combined (this will take about 10 seconds). Scrape down the bowl and beat again for 5 seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In another large bowl, beat the egg whites until stiff peaks form. Scoop 1 cup of the egg whites into the batter. Use a rubber spatula to gently fold them in. After about 30 seconds of folding, add the remaining egg whites and gently fold until they are almost completely combined. Do not rush the folding process.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour the batter into the prepared pan and bake for 40 to 50 minutes, rotating the pan halfway through the baking time, or until a small sharp knife inserted into the cake comes out clean. Transfer the pan to a wire rack to cool completely. Gently loosen the sides of the cake from the pan (I sometimes use an offset spatula for this) and turn it out onto the rack.")]), _vm._v(" "), _vm._m(195), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The cake can be stored at room temperature, covered tightly, for up to 3 days.")]), _vm._v(" "), _vm._m(196), _vm._v(" "), _vm._m(197), _vm._v(" "), _vm._m(198), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(199), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Throughout Renato’s entire childhood, he enjoyed this cake sans glaze. I can only assume that his mom thought a glaze was unnecessary and too sweet. However, I will admit that this quick-and-easy orange glaze makes a great visual and is a great way to use up the oranges you zested for the cake.")]), _vm._v(" "), _vm._m(200), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large bowl, whisk together the confectioners’ sugar and orange juice until the glaze is pourable. (If it is too thick, add a few more drops of orange juice. If it is too thin, add a few more tablespoons of confectioners’ sugar.) Drizzle the glaze along the crown of the Bundt, allowing it to drip down the sides. Allow the glaze to set before serving.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _vm._m(201), _vm._v(" "), _vm._m(202), _vm._v(" "), _vm._m(203), _vm._v(" "), _vm._m(204), _vm._v(" "), _vm._m(205), _vm._v(" "), _vm._m(206), _vm._v(" "), _vm._m(207), _vm._v(" "), _vm._m(208), _vm._v(" "), _vm._m(209), _vm._v(" "), _vm._m(210), _vm._v(" "), _vm._m(211), _vm._v(" "), _vm._m(212), _vm._v(" "), _vm._m(213), _vm._v(" "), _vm._m(214), _vm._v(" "), _vm._m(215), _vm._v(" "), _vm._m(216), _vm._v(" "), _vm._m(217), _vm._v(" "), _vm._m(218), _vm._v(" "), _vm._m(219), _vm._v(" "), _vm._m(220), _vm._v(" "), _vm._m(221), _vm._v(" "), _vm._m(222), _vm._v(" "), _vm._m(223), _vm._v(" "), _vm._m(224), _vm._v(" "), _vm._m(225), _vm._v(" "), _vm._m(226), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 375 degrees F and position the rack in the center. Butter the sides and bottom of a 9-by-13-inch glass or light-colored metal baking pan. Heat 1¼ cups water to boiling.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place the chocolate chips in a small bowl and toss them with the bourbon until covered. Sprinkle 2 tablespoons of the flour over the chips and toss until coated. This will keep them from settling at the bottom during baking. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place the oats and cubed butter in a large bowl. Pour the boiling water over the oat mixture, wait 30 seconds, and stir to moisten all the oats and melt the butter. Set the mixture aside for 25 to 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a separate bowl, whisk together the eggs, both sugars, salt, baking soda, baking powder, and cinnamon until combined. Fold in the cooled oatmeal and stir until well combined. Gently fold in the remaining flour and then the chocolate chips. Pour the batter into the prepared pan.")]), _vm._v(" "), _vm._m(227), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Let the cake cool in the pan on a wire rack for at least 30 minutes.")]), _vm._v(" "), _vm._m(228), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the bowl of a standing mixer fitted with the paddle attachment, beat the butter until it is completely smooth. Add the cream cheese and beat until combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Add the confectioners’ sugar and vanilla and beat until smooth, about 1 minute. Cover the bowl tightly and refrigerate for at least 30 minutes. (The frosting can be made 1 day ahead. Let it soften at room temperature before using.)")]), _vm._v(" "), _vm._m(229), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spread a thin, even layer of frosting over the cooled cake. Chill it for 15 minutes so that it can set. Slice and serve. The frosted cake can be kept, refrigerated and tightly covered, for up to 3 days. Bring the cake back to room temperature before serving. (An unfrosted one will keep for 3 days, tightly covered, at room temperature.)")]), _vm._v(" "), _vm._m(230), _vm._v(" "), _c('p', {
    staticClass: "bakedtext"
  }, [_vm._v("Unlike most of my favorite cakes, this one does not require a standing mixer. You do not have to cream any butter or whip any egg whites. You just dump in the ingredients, stir, and fold. It is quick, easy, and satisfying. The cake tastes great right out of the oven, but most of my tasters and testers think it’s best after resting for a day.")]), _vm._v(" "), _vm._m(231), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _vm._m(232), _vm._v(" "), _vm._m(233), _vm._v(" "), _vm._m(234), _vm._v(" "), _vm._m(235), _vm._v(" "), _vm._m(236), _vm._v(" "), _vm._m(237), _vm._v(" "), _vm._m(238), _vm._v(" "), _vm._m(239), _vm._v(" "), _vm._m(240), _vm._v(" "), _vm._m(241), _vm._v(" "), _vm._m(242), _vm._v(" "), _vm._m(243), _vm._v(" "), _vm._m(244), _vm._v(" "), _vm._m(245), _vm._v(" "), _vm._m(246), _vm._v(" "), _vm._m(247), _vm._v(" "), _vm._m(248), _vm._v(" "), _vm._m(249), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 400 degrees F. Lightly spray each cup of a standard 12-cup muffin pan with a little bit of vegetable spray and use a paper towel to spread the oil evenly along the bottom and up the sides of each cup.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a medium bowl, lightly whisk the eggs. Add the buttermilk, honey, and butter and whisk again until combined. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large bowl, whisk together the cornmeal, flour, baking powder, both sugars, and salt. Make a well in the middle of the dry ingredients, pour the wet ingredients into the well, and fold the dry into the wet until just mixed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fill each muffin cup about three-quarters full. Tap the bottom of the pan against counter to level the batter. Bake for 12 to 15 minutes, or until the tops are golden brown and a toothpick inserted in the center of a muffin comes out clean. Transfer the pan to a wire rack to cool for 10 to 15 minutes. Pop the muffins out while they’re still warm and serve them with a generous helping of butter or honey.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Leftover muffins (should you have any) taste great sliced and toasted in a toaster oven.")]), _vm._v(" "), _vm._m(250), _vm._v(" "), _c('p', {
    staticClass: "bakedtext"
  }, [_vm._v("I have spent my entire recipe-writing career advising people to avoid darkcolored baking pans. However, this is a recipe that is improved by baking it in a heavy, dark metal muffin or cupcake tin. The pan will “brown up” the edges and the sides of your muffins perfectly, leaving a tender crumb inside. If you don’t have a dark pan, no worries—they will still taste delicious.")]), _vm._v(" "), _vm._m(251), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _vm._m(252), _vm._v(" "), _vm._m(253), _vm._v(" "), _vm._m(254), _vm._v(" "), _vm._m(255), _vm._v(" "), _vm._m(256), _vm._v(" "), _vm._m(257), _vm._v(" "), _vm._m(258), _vm._v(" "), _vm._m(259), _vm._v(" "), _vm._m(260), _vm._v(" "), _vm._m(261), _vm._v(" "), _vm._m(262), _vm._v(" "), _vm._m(263), _vm._v(" "), _vm._m(264), _vm._v(" "), _vm._m(265), _vm._v(" "), _vm._m(266), _vm._v(" "), _vm._m(267), _vm._v(" "), _vm._m(268), _vm._v(" "), _vm._m(269), _vm._v(" "), _vm._m(270), _vm._v(" "), _vm._m(271), _vm._v(" "), _vm._m(272), _vm._v(" "), _vm._m(273), _vm._v(" "), _vm._m(274), _vm._v(" "), _vm._m(275), _vm._v(" "), _vm._m(276), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 350 degrees F and position the rack in the center. Butter the sides and bottom of a glass 9-by-13-inch pan. You can use a metal pan, but the edges of the cake may turn crispy (although that is not traditional, it is not an altogether bad thing).")]), _vm._v(" "), _vm._m(277), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a medium bowl, stir together both sugars, the salt, and cinnamon. Add the melted butter and whisk until combined. Fold in the flour until it is absorbed and set the mixture aside.")]), _vm._v(" "), _vm._m(278), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sift the flour, baking powder, baking soda, and salt together in a medium bowl. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the bowl of a standing mixer fitted with the paddle attachment, cream the butter until it is completely smooth and ribbonlike. Scrape down the bowl and add the sugar. Beat the mixture until it starts to look fluffy.")]), _vm._v(" "), _vm._m(279), _vm._v(" "), _vm._m(280), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour the batter into the prepared pan. Use your hands to scoop up a handful of the topping and make a fist. The topping should hold together. Break off in chunks and drop them over the cake. Repeat to use all the topping. Remember, the topping layer will look outrageously thick.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bake the cake for 45 to 55 minutes, or until a toothpick inserted in the middle comes out clean. Rotate the pan two times during the baking process. Cool the entire pan on a wire rack for about 30 minutes before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The cake will last for 3 days, tightly covered, at room temperature.")]), _vm._v(" "), _vm._m(281), _vm._v(" "), _c('p', {
    staticClass: "bakedtext"
  }, [_vm._v("Renato likes this cake with really huge crumb chunks. To attain these gargantuan boulders of sugar, make sure you give the crumb time to rest. I sometimes cheat the process and spread the topping mixture on a parchment-lined baking sheet to make it dry a bit faster; however, you don’t want it to dry out completely.")]), _vm._v(" "), _vm._m(282), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _vm._m(283), _vm._v(" "), _vm._m(284), _vm._v(" "), _vm._m(285), _vm._v(" "), _vm._m(286), _vm._v(" "), _vm._m(287), _vm._v(" "), _vm._m(288), _vm._v(" "), _vm._m(289), _vm._v(" "), _vm._m(290), _vm._v(" "), _vm._m(291), _vm._v(" "), _vm._m(292), _vm._v(" "), _vm._m(293), _vm._v(" "), _vm._m(294), _vm._v(" "), _vm._m(295), _vm._v(" "), _vm._m(296), _vm._v(" "), _vm._m(297), _vm._v(" "), _vm._m(298), _vm._v(" "), _vm._m(299), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a medium bowl, sift together the flour, salt, baking powder, and baking soda. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bring 1½ cups water to a boil. Place the cornmeal in a large bowl. Stirring continuously, slowly pour the boiling water over the cornmeal. Keep stirring until the mixture has cooled to lukewarm, almost room temperature. Add the brown sugar and stir until combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a medium bowl, whisk the eggs until pale yellow. Add the buttermilk and whisk until blended. Add the flour mixture, alternating with the buttermilk mixture, to the cornmeal in three parts (beginning and ending with the flour mixture), stirring after each addition until just combined. Stir in the melted butter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Heat a skillet or griddle pan over medium-low heat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Add 1 or 2 tablespoons butter to the skillet and make sure it coats the surface. (Note: The first cornmeal griddle cake soaks up a fair amount of the butter and generally speaking, will not be your best handiwork. However, the subsequent griddle cakes will be a thing of beauty.) Drop griddle cakes in ¼-cup batches into the skillet (they will spread—do not crowd the pan). Cook until the bottoms are medium-brown, about 3 minutes, and the tops are bubbly, then flip the griddle cakes over and cook the other side for about 2 minutes and serve immediately. Continue cooking and serving until all the batter is gone. Serve with generous amounts of sweet butter.")]), _vm._v(" "), _vm._m(300), _vm._v(" "), _c('p', {
    staticClass: "bakedtext"
  }, [_vm._v("Generally speaking, you can substitute white cornmeal for yellow cornmeal in most recipes, including this one. I believe that yellow cornmeal (which is made from yellow corn) has a “cornier” taste and prefer it for that reason. White cornmeal is made from white corn, obviously, and some people prefer its less aggressive corn taste.")]), _vm._v(" "), _vm._m(301), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _vm._m(302), _vm._v(" "), _vm._m(303), _vm._v(" "), _vm._m(304), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I could eat malted waffles all day long, every day, and be quite satisfied. The sweet nuttiness of the malt powder renders the ordinary, simple waffle especially addictive. Personally, I like these waffles drizzled with a bit of melted butter and smattering of chocolate chips, but they taste great with pure maple syrup or confectioners’ sugar and whipped cream. And if you don’t have a waffle iron, you now know what to ask for on your approaching birthday. Or you could just borrow one from a wacky, waffle-addicted friend.")]), _vm._v(" "), _vm._m(305), _vm._v(" "), _vm._m(306), _vm._v(" "), _vm._m(307), _vm._v(" "), _vm._m(308), _vm._v(" "), _vm._m(309), _vm._v(" "), _vm._m(310), _vm._v(" "), _vm._m(311), _vm._v(" "), _vm._m(312), _vm._v(" "), _vm._m(313), _vm._v(" "), _vm._m(314), _vm._v(" "), _vm._m(315), _vm._v(" "), _vm._m(316), _vm._v(" "), _vm._m(317), _vm._v(" "), _vm._m(318), _vm._v(" "), _vm._m(319), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 225 degrees F. Prepare a waffle iron with cooking spray or vegetable oil per the manufacturer’s instructions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large bowl, whisk together the flour, malt powder, sugar, baking soda, baking powder, and salt. In a separate bowl, whisk the eggs slightly, add the buttermilk and butter, and whisk again.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Make a well in the center of the dry ingredients and pour the buttermilk mixture into it. Fold the dry ingredients into the wet ever so gently until just combined—there will be some visible lumps. Cook the waffles according to the manufacturer’s instructions for your iron. Generally speaking, you will use ¼ to ½ cup batter per waffle (depending on the size of your waffle iron). Cook the waffles until they are golden brown or a little darker (I actually prefer darker ones). Transfer the waffles directly to a rack in your oven to keep them warm while you make the rest. Serve immediately with maple syrup, butter, and chocolate chips.")]), _vm._v(" "), _vm._m(320), _vm._v(" "), _c('p', {
    staticClass: "bakedtext"
  }, [_vm._v("Waffles, like most batter cakes, go from light and fluffy to tough and doughy really quickly. All it takes is a bit of overmixing when you combine wet and dry ingredients, and suddenly you have lost your “waffle.” While most people are considerate and careful when making a cake, they tend to be less so when making breakfast items. Chalk that up to the heartier mentality that breakfast conjures.")]), _vm._v(" "), _vm._m(321), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _vm._m(322), _vm._v(" "), _vm._m(323), _vm._v(" "), _vm._m(324), _vm._v(" "), _vm._m(325), _vm._v(" "), _vm._m(326), _vm._v(" "), _vm._m(327), _vm._v(" "), _vm._m(328), _vm._v(" "), _vm._m(329), _vm._v(" "), _vm._m(330), _vm._v(" "), _vm._m(331), _vm._v(" "), _vm._m(332), _vm._v(" "), _vm._m(333), _vm._v(" "), _vm._m(334), _vm._v(" "), _vm._m(335), _vm._v(" "), _vm._m(336), _vm._v(" "), _vm._m(337), _vm._v(" "), _vm._m(338), _vm._v(" "), _vm._m(339), _vm._v(" "), _vm._m(340), _vm._v(" "), _vm._m(341), _vm._v(" "), _vm._m(342), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Generously butter the sides and bottom of an 8-inch square baking pan. Cut the loaf into 1- or 1½-inch slices and arrange them in the pan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large bowl, whisk the eggs just until they break up. Add the half-and-half, milk, vanilla, and cinnamon. Whisk until combined. Pour the mixture over the bread slices. Cover tightly with plastic wrap and refrigerate for at least 8 hours or overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 350 degrees F. Use your fingers to flip each bread slice over, making sure to coat the entire surface in the liquid. Arrange the bread in an overlapping pattern, sprinkle it with almonds, and bake for 35 to 40 minutes, or until the French toast is golden brown and the mixture is puffy. Set the French toast aside to cool in the pan.")]), _vm._v(" "), _vm._m(343), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a small saucepan, toss the raspberries with the sugar. Cook the mixture over low heat until the berries start to break down, about 10 minutes. Strain the cooked raspberry sauce into a bowl to remove the seeds, then stir in the lemon juice.")]), _vm._v(" "), _vm._m(344), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour the raspberry sauce directly over the warm French toast (or serve it alongside in a gravy boat) and serve immediately. Top with whole fresh raspberries, if you have any left over.")]), _vm._v(" "), _vm._m(345), _vm._v(" "), _c('p', {
    staticClass: "bakedtext"
  }, [_vm._v("If you are interested in a creamier bread pudding.type recipe, increase the half and-half to 1 cup and the milk to 3.4 cup. And any hearty, crusty white bread makes a great substitute for the baguette.")]), _vm._v(" "), _vm._m(346), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _vm._m(347), _vm._v(" "), _vm._m(348), _vm._v(" "), _vm._m(349), _vm._v(" "), _vm._m(350), _vm._v(" "), _vm._m(351), _vm._v(" "), _vm._m(352), _vm._v(" "), _vm._m(353), _vm._v(" "), _vm._m(354), _vm._v(" "), _vm._m(355), _vm._v(" "), _vm._m(356), _vm._v(" "), _vm._m(357), _vm._v(" "), _vm._m(358), _vm._v(" "), _vm._m(359), _vm._v(" "), _vm._m(360), _vm._v(" "), _vm._m(361), _vm._v(" "), _vm._m(362), _vm._v(" "), _vm._m(363), _vm._v(" "), _vm._m(364), _vm._v(" "), _vm._m(365), _vm._v(" "), _vm._m(366), _vm._v(" "), _vm._m(367), _vm._v(" "), _vm._m(368), _vm._v(" "), _vm._m(369), _vm._v(" "), _vm._m(370), _vm._v(" "), _vm._m(371), _vm._v(" "), _vm._m(372), _vm._v(" "), _vm._m(373), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 350 degrees F and position the rack in the center. Butter a 9-by-5-inch loaf pan, dust it with flour, and knock out the excess flour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place the brown sugar in the bowl of a standing mixer fitted with the paddle attachment. Press out any lumps with the back of a large spoon. Add the cocoa, flour, granulated sugar, baking soda, baking powder, and salt. Scrape down the sides and bottom of the bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a separate bowl, whisk the eggs and egg yolk until blended, then add the buttermilk, oil, and vanilla; whisk until combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Turn the mixer to low and slowly stream the wet ingredients into the dry ones, mixing just until combined. Stir in the dark chocolate chunks by hand.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour the batter into the prepared pan and bake for 1 hour to 1 hour and 10 minutes, or until a toothpick inserted in the center of the loaf comes out clean.")]), _vm._v(" "), _vm._m(374), _vm._v(" "), _vm._m(375), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the bowl of a standing mixer fitted with the paddle attachment, beat together the cream cheese and peanut butter until smooth. Add the sugar and beat until incorporated. (If you are not using the spread immediately, place it in a ramekin, tightly cover it in plastic wrap, and refrigerate it for up to 3 days.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serve the loaf plain or toasted, topped with the peanut butter spread.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The loaf will keep, in an airtight container or wrapped tightly, at room temperature for up to 3 days.")]), _vm._v(" "), _vm._m(376), _vm._v(" "), _c('p', {
    staticClass: "bakedtext"
  }, [_vm._v("This loaf is the ultimate gift. I double (or triple) the recipe, cool the loaves completely, and remove them from the pans. To give the loaves a nifty bakery look, I like to wrap the loaves in brown parchment paper, and then wrap them in plastic and drop them off to friends along with a card.")]), _vm._v(" "), _vm._m(377), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(378), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("During many bouts of testing several recipes for various books and articles, I noticed something quite peculiar: loaves (or quick breads) actually look and taste better baked in a conventional home oven compared with the large convection-style ovens often found in restaurants and patisseries (mine included). The longer bake of a conventional oven coupled with the absence of a convection fan allows the loaf to bake up from the bottom, creating a perfect dome, crack, and moist crumb. The convection fan, while perfect for cookies and most cakes, often bakes the loaves a tad too quick, resulting in a shorter, tighter loaf—one that is still quite delicious, but not as impressive as those produced in a home oven.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("That said, I compiled a list of a few home loaf baking tips:")]), _vm._v(" "), _vm._m(379), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("You can double (or triple) almost any loaf recipe without fail.")]), _vm._v(" "), _vm._m(380), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Make sure your loaf is baked all the way through. This is important, as many loaves are tricky and appear baked from the outside (including puffy dome and crack) while remaining undercooked. If you pull your loaf out early, it will collapse in on itself, creating a “sunken” loaf.")]), _vm._v(" "), _vm._m(381), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Loaves freeze extremely well. Let cool entirely to room temperature and just wrap tightly in two layers of plastic wrap and one layer of aluminum foil, and freeze for up two months. Bring the loaves back to room temperature by way of your refrigerator for 8 hours, then let sit at room temperature for 4 hours before unwrapping the loaves.")]), _vm._v(" "), _vm._m(382), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Mix-ins (chocolate chips, fruits, nuts) are hit-and-miss with loaves, depending on the density of your batter, and may sink to the bottom during baking. Toss your mix-ins in a bit of liquor, then coat them in flour to allow the mix-ins to become suspended in the batter.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _vm._m(383)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "h2a",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-01.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchaprec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev1"
    }
  }, [_c('strong', [_vm._v("MONKEY BUBBLE BREAD")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchaprec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev2"
    }
  }, [_c('strong', [_vm._v("PUMPKIN CHEDDAR MUFFINS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchaprec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev3"
    }
  }, [_c('strong', [_vm._v("FARM STAND BUTTERMILK DOUGHNUTS "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THREE WAYS")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchaprec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev4"
    }
  }, [_c('strong', [_vm._v("NUTELLA SCONES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchaprec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev5"
    }
  }, [_c('strong', [_vm._v("CARROT COCONUT SCONES "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WITH CITRUS GLAZE")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchaprec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev6"
    }
  }, [_c('strong', [_vm._v("BAKED CHEESE GRITS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchaprec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev7"
    }
  }, [_c('strong', [_vm._v("MOM’S OLIVE OIL ORANGE BUNDT")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchaprec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev8"
    }
  }, [_c('strong', [_vm._v("OATMEAL CHOCOLATE CHIP CAKE "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WITH CREAM CHEESE FROSTING")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchaprec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev9"
    }
  }, [_c('strong', [_vm._v("HONEY CORN MUFFINS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchaprec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev10"
    }
  }, [_c('strong', [_vm._v("NEW YORK-STYLE CRUMB CAKE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchaprec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev11"
    }
  }, [_c('strong', [_vm._v("CORNMEAL GRIDDLE CAKES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchaprec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev12"
    }
  }, [_c('strong', [_vm._v("MALTED WAFFLES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchaprec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev13"
    }
  }, [_c('strong', [_vm._v("BAKED FRENCH TOAST")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchaprec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev14"
    }
  }, [_c('strong', [_vm._v("DOUBLE-CHOCOLATE LOAF "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WITH PEANUT BUTTER CREAM CHEESE SPREAD")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_vm._v("My carefree roll-out-of-bed-and-grab-your-own-breakfast attitude is largely a part of my upbringing. Mom encouraged the scour-and-devour breakfast scenario that still is part my daily routine. On occasion we were treated to last-minute innovations like a spruced-up muffin mix (usually loaded with butterscotch or chocolate chips) or a pancake burdened with more toppings than a tricked-out ice cream sundae. Other times, it was a simple "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("store-bought, and probably not very good, coffee cake. My breakfast never looked like the hearty abundance of a tweaked-and-Photoshopped Denny’s picture menu.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_vm._v("While digging for this book, I unearthed more recipes for breakfast than any other section. People are passionate about their first meal of the day, and the nostalgia runs deep—deeper than with most recipes. I whittled the written and oral submissions down, keeping to the sweeter side of things, and edited them down again by preserving the items that felt the most homey without being too kitsch. I can honestly say that I had the hardest time regulating myself with breakfast during the book’s testing phase. One time I lost self-control, nearly consuming half a loaf of "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev1"
    }
  }, [_vm._v("Monkey Bubble Bread")]), _vm._v(" all by my lonesome. The other recipes in this chapter are equally delicious. I still daydream about the "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev14"
    }
  }, [_vm._v("Double-Chocolate Loaf")]), _vm._v(" with Peanut Butter Cream Cheese Spread. It is a rewarding and handsome breakfast loaf with a sinful flair. "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev7"
    }
  }, [_vm._v("Mom’s Olive Oil Orange Bundt")]), _vm._v(" is coffee-klatch heaven, and the "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev12"
    }
  }, [_vm._v("Malted Waffles")]), _vm._v(" are a great excuse to use your waffle iron. If you are one of those rare anti-sweet breakfast people, I recommend the "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev6"
    }
  }, [_vm._v("Baked Cheese Grits")]), _vm._v(". Actually, I recommend the cheese grits no matter what. Have a great breakfast.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "imageheight",
    attrs: {
      "id": "ch01lev1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0028-01.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "h3cap",
    attrs: {
      "id": "zch01lev1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('strong', [_vm._v("MONKEY BUBBLE BREAD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("I SUGGEST ONLY MAKING THIS FROM-SCRATCH BREAD IF YOU ARE HAVING A LARGE GATHERING.")]), _vm._v(" Otherwise, you could end up (like me) eating more than you should. Simply put, this is addictive stuff. I liken these warm, gooey bread balls to the most amazing glazed doughnut hole you have ever had. There are several recipes floating about for monkey bread that use canned biscuit dough, but I ask you to kindly refrain from this expedient fix because the result won’t be as tasty, and it is more expensive. The origin of the name monkey bread or bubble bread is quite hard to pinpoint, and while many dubious answers exist (the bread resembles a monkey puzzle tree or monkeys love to pull things apart), none of them are definitive, and some are cloyingly cute. I hate cloyingly cute. Suffice it to say that the source of the name is just one of life’s great mysteries, and we should leave it at that.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("YIELD: ONE 10-INCH BUNDT")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "rec-ingredient"
  }, [_c('strong', [_c('em', [_vm._v("Ingredients")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cooka",
    attrs: {
      "id": "rrlink1"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#sslink1"
    }
  }, [_vm._v("FOR THE MONKEY BUBBLE BREAD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1¼ cups whole milk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 teaspoons instant yeast")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("4 cups all-purpose flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("5 tablespoons sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 egg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("5 tablespoons unsalted butter, melted")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cooka",
    attrs: {
      "id": "rrlink2"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#sslink2"
    }
  }, [_vm._v("FOR THE CINNAMON SUGAR COATING")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1¼ cups firmly packed dark brown sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 teaspoons cinnamon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ cup (1 stick) unsalted butter, melted and cooled")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "sslink1"
    }
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#rrlink1"
    }
  }, [_vm._v("MAKE THE MONKEY BUBBLE BREAD")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("Spray the bottom and sides of a large bowl with cooking spray. Place the dough in the bowl and roll it around to make sure it is completely covered in oil. Cover the bowl with plastic wrap or a dish towel and let it rest in a warm area until the dough has doubled in size, approximately 1 hour.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "sslink2"
    }
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#rrlink2"
    }
  }, [_vm._v("MAKE THE CINNAMON SUGAR COATING")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("ASSEMBLE THE BREAD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "baked"
  }, [_c('strong', [_c('em', [_vm._v("Baked Note")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('strong', [_vm._v("PUMPKIN CHEDDAR MUFFINS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("IF THERE WERE A PLACE ON EARTH WHERE YOU COULD EXPERIENCE A NEW ENGLAND FALL FOR TEN MONTHS OUT OF THE YEAR, I WOULD PROBABLY MOVE THERE.")]), _vm._v(" I would pursue leaf peeping like a sport, build a crackling fire nightly, and indulge in every hearty autumn recipe at my whim. Until I find this utopia, I will make do with my annual three months of fall. I will churn through umpteen pumpkins (pumpkin bread, pumpkin soup, toasted pumpkin seeds) and hundreds of pounds of Vermont cheddar (grilled cheese, cheese and crackers, fondue), and on a few mornings, I will combine the two in this very autumnal muffin. Like all good muffins, this one is quick to put together. The pumpkin base is moist but spiced with cayenne and black pepper so the sharpness of the cheddar has a chance to shine. I also like to top the muffin with a little extra cheese, so you get a savory-sweet morning experience.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("YIELD: 12 MUFFINS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "rec-ingredient"
  }, [_c('strong', [_c('em', [_vm._v("Ingredients")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 cup canned solid-pack pumpkin puree")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("3 tablespoons sour cream")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 large eggs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ cup (1 stick) unsalted butter, melted and cooled")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 cups all-purpose flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1½ teaspoons baking powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¼ teaspoon cayenne pepper")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1½ teaspoons salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1½ teaspoons freshly ground black pepper")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ cup firmly packed dark brown sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1¼ cups (about 4 ounces) grated sharp cheddar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 tablespoons pumpkin seeds, optional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "baked"
  }, [_c('strong', [_c('em', [_vm._v("Baked Note")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "imageheight",
    attrs: {
      "id": "ch01lev3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0033-01.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "h3cap",
    attrs: {
      "id": "zch01lev3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('strong', [_vm._v("FARM STAND BUTTERMILK DOUGHNUTS "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THREE WAYS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("IF I WERE A BETTER PERSON, I WOULD MAKE THESE MORE OFTEN.")]), _vm._v(" I would avoid the supermarket or mass-produced doughnut. I would take a stand and refuse to eat a doughnut that was not prepared by hand and eaten fresh from the fryer. These delicious doughnuts are what a doughnut should be, the type you might pick up from the side of the road at a local farm or farm stand. And though I’m often too lazy and lethargic to fire up the fryer, they really aren’t that difficult to make.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("YIELD: ABOUT 10 LARGE DOUGHNUTS PLUS DOUGHNUT HOLES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "rec-ingredient"
  }, [_c('strong', [_c('em', [_vm._v("Ingredients")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cooka",
    attrs: {
      "id": "rrlink3"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#sslink3"
    }
  }, [_vm._v("FOR THE DOUGHNUTS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("3½ cups all-purpose flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¾ cup granulated sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ teaspoon baking soda")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 teaspoons baking powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon freshly grated nutmeg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon cinnamon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 large eggs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¾ cup buttermilk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¼ cup sour cream")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¼ cup (½ stick) unsalted butter, melted and slightly browned and cooled")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("Vegetable oil for frying")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cooka",
    attrs: {
      "id": "rrlink4"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#sslink4"
    }
  }, [_vm._v("FOR THE CHOCOLATE DIP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("4 ounces good-quality dark chocolate (60 to 70%), coarsely chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ cup heavy cream")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 tablespoons unsalted butter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("Sprinkles to decorate (optional)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cooka",
    attrs: {
      "id": "rrlink5"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#sslink5"
    }
  }, [_vm._v("FOR THE VANILLA GLAZE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 cups confectioners’ sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¼ cup whole milk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon vanilla paste or 1½ teaspoons pure vanilla extract")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("Sprinkles to decorate (optional)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cooka",
    attrs: {
      "id": "rrlink6"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#sslink6"
    }
  }, [_vm._v("FOR THE CINNAMON SUGAR")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1¼ cups granulated sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("3 tablespoons cinnamon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "sslink3"
    }
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#rrlink3"
    }
  }, [_vm._v("MAKE THE DOUGHNUTS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("Use two round cutters (3¼ inch and 1½ inch for large doughnuts; 2½ inch and 1 inch for smaller doughnuts). Dip the large cutter in flour and press out the rounds. Dip the smaller cutter in the flour and cut out the center of each dough round. Arrange both doughnuts and doughnut holes on the parchment-lined baking sheet, pat the dough scraps back together, and use them to make as many more doughnuts and doughnut holes as possible. Chill the dough while you heat the oil.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "sslink4"
    }
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#rrlink4"
    }
  }, [_vm._v("MAKE THE CHOCOLATE DIP")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "sslink5"
    }
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#rrlink5"
    }
  }, [_vm._v("MAKE THE VANILLA GLAZE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "sslink6"
    }
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#rrlink6"
    }
  }, [_vm._v("MAKE THE CINNAMON SUGAR")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("TO FRY THE DOUGHNUTS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('strong', [_vm._v("ASSEMBLE THE DOUGHNUTS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "baked"
  }, [_c('strong', [_c('em', [_vm._v("Baked Note")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "imageheight",
    attrs: {
      "id": "ch01lev4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0037-01.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "h3cap",
    attrs: {
      "id": "zch01lev4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('strong', [_vm._v("NUTELLA SCONES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("YES, RENATO AND I LOVE NUTELLA, THE LITTLE (OR BIG) JAR OF HAZELNUT AND CHOCOLATE BLISS FROM ITALY.")]), _vm._v(" Once stocked only by specialty stores, Nutella can now be found virtually everywhere. If you have not tried it, I beg you to stop everything, go to the nearest grocery store, and buy at least two jars: one for baking and one for a daily midday boost directly from said jar to your mouth.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_vm._v("These scones (secretly my favorite scones) have a decent-size dollop of Nutella folded into a cocoa-based dough. They aren’t overly sweet, and the hazelnuts provide a great texture. Technically, they are still a breakfast treat, but they tend to make a bigger splash at brunch when people feel better about eating indulgently. Scones, no matter the ingredients, are still technically more difficult to put together than a muffin or quick bread. They require a little practice to perfect (i.e., getting a feel for the texture you want as you work in the butter and making sure you don’t overwork the dough). However, once you master the scone, it will take you just a few moments to put together, bake, and serve a comfy little breakfast or tea snack. If you prefer to make your own, all-natural “Nutella,” see the "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#page_198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homemade Nutella")]), _vm._v(" recipe.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("YIELD: 6 TO 8 SCONES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "rec-ingredient"
  }, [_c('strong', [_c('em', [_vm._v("Ingredients")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 cups unbleached all-purpose flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¼ cup granulated sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¼ cup dark unsweetened cocoa powder (like Valrhona)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 tablespoon baking powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ teaspoon salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("6 tablespoons (¾ stick) cold unsalted butter, cut into chunks")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 large egg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ cup heavy cream")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¾ cup toasted hazelnuts, coarsely chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ cup Nutella")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("Cut the dough into 6 or 8 wedges and place them on the prepared baking sheet. Bake the scones for 18 to 20 minutes, rotating the baking sheet halfway through, or until a toothpick inserted into the center of a scone comes out clean. Do not overbake.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("ASSEMBLE THE NUTELLA SCONES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "baked"
  }, [_c('strong', [_c('em', [_vm._v("Baked Note")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('strong', [_vm._v("CARROT COCONUT SCONES "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WITH CITRUS GLAZE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CARROTS HAVE LONG BELONGED TO THE SWEET BAKING SPECTRUM.")]), _vm._v(" In fact, it is likely that cakes sweetened with carrot have been around for many centuries and that carrot cake–type recipes like those we are familiar with today started appearing as early as 1914. Carrots have a high sugar content and subtle taste, which makes them easy to sneak into all manner of baked goods. Additionally, I have succumbed to deep self-delusion and equate all carrot baked things with health and nutrition. True, carrots contain vast amounts of vitamin A and dietary fiber, but a scone is still a scone (and for that matter, a cake is still a cake). These carrot scones are delectable whatever their nutritional value. (Like all scones, they are at their very best the day they are made.) They are dense without being heavy, sweet without being cloying, and the coconut adds some simple texture.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("YIELD: 6 TO 8 SCONES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "rec-ingredient"
  }, [_c('strong', [_c('em', [_vm._v("Ingredients")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cooka",
    attrs: {
      "id": "rrlink7"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#sslink7"
    }
  }, [_vm._v("FOR THE SCONES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2¾ cups all-purpose flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ cup granulated sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ cup rolled oats")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 tablespoon baking powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¼ teaspoon salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 cup shredded sweetened coconut")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ cup (1 stick) cold unsalted butter, cut into ½-inch chunks")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 large egg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¾ cup buttermilk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 tablespoon pure vanilla extract")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¼ cup carrot puree")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 egg white, beaten")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cooka",
    attrs: {
      "id": "rrlink8"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#sslink8"
    }
  }, [_vm._v("FOR THE CITRUS GLAZE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 tablespoon fresh lemon juice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 tablespoons fresh orange juice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 cup confectioners’ sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "sslink7"
    }
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#rrlink7"
    }
  }, [_vm._v("MAKE THE CARROT COCONUT SCONES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("Cut the dough into 6 or 8 wedges and place the scones on the prepared baking sheet. Brush the tops with the egg white wash. Bake for 18 to 20 minutes, rotating the baking sheet halfway through, or until a toothpick inserted into the center of a scone comes out clean. Do not overbake.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "sslink8"
    }
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#rrlink8"
    }
  }, [_vm._v("MAKE THE CITRUS GLAZE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "baked"
  }, [_c('strong', [_c('em', [_vm._v("Baked Note")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sidebartitle"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0034-01.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("1 medium carrot"), _c('br'), _vm._v("¼ cup orange juice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('strong', [_vm._v("BAKED CHEESE GRITS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("I HAD TO SNEAK THIS SAVORY RECIPE INTO THE BOOK.")]), _vm._v(" Though, thematically, it is quite different from everything else in this book, grits—specifically these baked cheese grits—make up a large portion of my cooking and baking DNA. I was first introduced to grits—real stone-ground grits swimming in butter and cheese—while nursing a fairly nasty hangover during my first year of college at the University of Alabama, Tuscaloosa. It was the beginning of a beautiful relationship that has outlasted many others. Grits, a staple of Southern cuisine, are as homey, comfortable, variable, and delicious as America’s beloved macaroni and cheese. I hope everyone will have a chance to try this neglected delicacy, as it is more than just a Southern caricature and maligned stereotype. Honestly, grits in any form please me. They are wonderful without adornment, and even better with copious amounts of butter and cheese. This basic recipe for baked cheese grits (adapted from "), _c('em', [_vm._v("The Lee Bros. Southern Cookbook")]), _vm._v(") is a breakfast crowd-pleaser and the perfect accompaniment to bacon or sausages.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("YIELD: 4 DECENT-SIZE SERVINGS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "rec-ingredient"
  }, [_c('strong', [_c('em', [_vm._v("Ingredients")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 cups whole milk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 cup stone-ground grits")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon kosher salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon freshly ground black pepper")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 cup, packed, grated extra-sharp cheddar cheese, about 4 ounces")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 cup, packed, grated Monterey Jack cheese, about 4 ounces")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 tablespoon unsalted butter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "baked"
  }, [_c('strong', [_c('em', [_vm._v("Baked Note")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "imageheight",
    attrs: {
      "id": "ch01lev7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0043-01.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "h3cap",
    attrs: {
      "id": "zch01lev7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('strong', [_vm._v("MOM’S OLIVE OIL ORANGE BUNDT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TECHNICALLY SPEAKING, THIS LIGHT AND PLEASING ORANGE CAKE IS NOT RENATO’S MOM’S.")]), _vm._v(" Renato’s mom would be the first to admit this. It belonged to his mother’s neighbor, a lovely French woman named Annette, who arrived and left their neighborhood in Queens before he was born. So, yes, this is really Annette’s Olive Oil Orange Bundt (Annette from Marseille, France, to give proper attribution), but his mom adapted and baked it so many times, he truly associates it only with her. Mom’s Olive Oil Orange Bundt is great for breakfast with tea and coffee, or sliced and served in the afternoon with a tart dessert wine.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("YIELD: ONE 10-INCH BUNDT")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "rec-ingredient"
  }, [_c('strong', [_c('em', [_vm._v("Ingredients")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("3 cups all-purpose flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 tablespoon baking powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ teaspoon salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("4 large eggs, separated")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 cups granulated sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 cup plain yogurt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¾ cup good-quality extra-virgin olive oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("Freshly grated zest of 2 oranges")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon vanilla paste, or 1½ teaspoons pure vanilla extract")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¼ cup confectioners’ sugar, sifted, for dusting")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("Just before serving, dust the cake with the confectioners’ sugar.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "baked"
  }, [_c('strong', [_c('em', [_vm._v("Baked Note")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bakedtext"
  }, [_vm._v("When making this cake, try to use a really good, fruity olive oil (Renato likes Paesano extra-virgin olive oil) to bring out the citrusy tones in the cake. Also, you’ll notice I skipped glazing this cake altogether (a rarity at Baked) because the simple dusting of confectioners’ sugar is really all it needs. If you insist on a glaze, though, I won’t stop you (see the "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#sidebar1"
    }
  }, [_vm._v("sidebar")]), _vm._v(").")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sidebartitle",
    attrs: {
      "id": "sidebar1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0038-01.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("2 cups confectioners’ sugar"), _c('br'), _vm._v("¼ cup fresh orange juice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('strong', [_vm._v("OATMEAL CHOCOLATE CHIP CAKE "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WITH CREAM CHEESE FROSTING")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("IT MAY SOUND DEVILISH, BUT THIS CAKE—WHICH IS LIKE A DENSE BANANA BREAD WITH THE FLAVOR OF A REALLY GOOD OATMEAL CHOCOLATE CHIP COOKIE—IS PERFECT FOR BREAKFAST.")]), _vm._v(" It is like coffee cake for the cookie enthusiast. Of course, it is also ideal for either an afternoon or a midnight snack, but it was conceived as a breakfast treat. The original recipe was buried deep within a Time-Life cookbook, and it revealed a split personality: Half the cake felt like an ambrosia, while the other half felt like a fancy coffee-klatch dessert. It was the South (ambrosia) meets North (coffee klatch) aspect of the dessert that originally caught my eye, and I have been making it ever since. Though I am hesitant to mention it, the delicious cream cheese frosting is not necessary if you are attempting a strict coffee cake interpretation. If you are serving it as an afternoon snack, however, the frosting adds a sweet little sugar rush.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("YIELD: ONE 9-BY-13-INCH CAKE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "rec-ingredient"
  }, [_c('strong', [_c('em', [_vm._v("Ingredients")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cooka",
    attrs: {
      "id": "rrlink9"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#sslink9"
    }
  }, [_vm._v("FOR THE CAKE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("8 ounces chocolate chips")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ teaspoon bourbon, Scotch, or favorite liquor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1½ cups plus 2 tablespoons all-purpose flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 cup rolled oats")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ cup (1 stick) unsalted butter, cut into small cubes, at room temperature")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 eggs, slightly beaten")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¾ cup granulated sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1¼ cups firmly packed dark brown sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ teaspoon salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon baking soda")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon baking powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1½ teaspoons cinnamon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cooka",
    attrs: {
      "id": "rrlink10"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#sslink10"
    }
  }, [_vm._v("FOR THE CREAM CHEESE FROSTING")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("5 tablespoons unsalted butter, softened")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("5½ ounces cream cheese, softened")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 cups confectioners’ sugar, sifted")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¾ teaspoon pure vanilla extract")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "sslink9"
    }
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#rrlink9"
    }
  }, [_vm._v("MAKE THE CAKE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("Bake the cake for 40 to 45 minutes, or until a toothpick inserted in the center comes out clean.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "sslink10"
    }
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#rrlink10"
    }
  }, [_vm._v("MAKE THE CREAM CHEESE FROSTING")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("ASSEMBLE THE CAKE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "baked"
  }, [_c('strong', [_c('em', [_vm._v("Baked Note")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('strong', [_vm._v("HONEY CORN MUFFINS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THIS MUFFIN MOMENT BEGAN FOR RENATO WITH A BOX OF BASIC JIFFY-BRAND CORN MUFFIN MIX.")]), _vm._v(" The boxed mix, ever present in his college apartment, produces a simple and straightforward muffin. It is not revelatory. It is sturdy and sound. However, Renato also found that it is extremely versatile as a base recipe, and he set about playing with new additions to zest up the Jiffy muffin. He tried chipotle for a little smoky heat, canned corn for texture, and honey for sweetness. The honey corn muffin was the clear favorite, and he eventually conceived of a recipe that didn’t rely on the boxed mix. The honey adds a hint of sweetness without being overt, and the muffin is light (some would say more Northern in origin) without losing any character. Serve these warm and with lashings of butter and more honey.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("YIELD: 12 MUFFINS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "rec-ingredient"
  }, [_c('strong', [_c('em', [_vm._v("Ingredients")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 large eggs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 cup buttermilk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¼ cup honey")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¼ cup (½ stick) unsalted butter, melted and cooled")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1¼ cups yellow cornmeal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¾ cup all-purpose flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 tablespoon baking powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¼ cup firmly packed light brown sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 tablespoons granulated sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("Butter or honey to taste (for serving)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "baked"
  }, [_c('strong', [_c('em', [_vm._v("Baked Note")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "imageheight",
    attrs: {
      "id": "ch01lev10"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0048-01.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "h3cap",
    attrs: {
      "id": "zch01lev10"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('strong', [_vm._v("NEW YORK-STYLE CRUMB CAKE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("I LEARNED THE HARD WAY: NEW YORK-STYLE CRUMB CAKE IS NOT TO BE CONFUSED WITH COFFEE CAKE—EVER")]), _vm._v(". A very passionate born and bred New Yorker (aka Renato Poliafito) informed me, quite brutally, about the not-so-subtle differences between the two. It was a dressing down I won’t ever forget. It was as if I’d confused Picasso with Norman Rockwell. First and foremost, New York crumb cake is all about the crumb topping. It is obscenely large in proportion to the cake. In fact, the topping is nearly identical in thickness to—or even thicker than—the cake. Second of all, the crumb should never contain nuts—no crushed nuts, no whole nuts, no hint of a nut whatsoever. Finally, a true New York crumb cake is swirl free. This was the hardest part for me to reconcile, as I love a chocolate nut swirl, and this cake seems like a natural swirl candidate. But I obeyed the New York Crumb Commandments and am now a convert myself.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("YIELD: ONE 9-BY-13-INCH CAKE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "rec-ingredient"
  }, [_c('strong', [_c('em', [_vm._v("Ingredients")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cooka",
    attrs: {
      "id": "rrlink11"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#sslink11"
    }
  }, [_vm._v("FOR THE CRUMB TOPPING")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 cup firmly packed dark brown sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ cup granulated sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ teaspoon salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1½ tablespoons cinnamon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 cup (2 sticks) unsalted butter, melted and warm")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2½ cups all-purpose flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cooka",
    attrs: {
      "id": "rrlink12"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#sslink12"
    }
  }, [_vm._v("FOR THE CAKE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2½ cups all-purpose flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¾ teaspoon baking powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon baking soda")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ teaspoon salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("12 tablespoons (1½ sticks) unsalted butter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1½ cups granulated sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 large eggs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1¼ cups sour cream")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon pure vanilla extract")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "sslink11"
    }
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#rrlink11"
    }
  }, [_vm._v("MAKE THE CRUMB TOPPING")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "sslink12"
    }
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#rrlink12"
    }
  }, [_vm._v("MAKE THE CAKE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("Add the eggs, one at a time, and beat until incorporated. Scrape down the sides of the bowl and mix again for 30 seconds. Add the sour cream and vanilla and beat just until incorporated. Add the dry ingredients in three parts, scraping down the bowl before each addition, beating only until it is just incorporated.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("ASSEMBLE THE CAKE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "baked"
  }, [_c('strong', [_c('em', [_vm._v("Baked Note")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev11"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('strong', [_vm._v("CORNMEAL GRIDDLE CAKES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE CORNMEAL GRIDDLE CAKE IS A HERITAGE RECIPE SO STEEPED IN NOSTALGIA THAT MANY PEOPLE ASSUME IT IS A CREATION OF THEIR FAMILY OR SMALL TOWN, BUT LIKE SO MANY OLD-SCHOOL RECIPES, THE ORIGINS ARE CLOUDY AT BEST.")]), _vm._v(" The term “griddle cake” is nearly synonymous with pancakes, flapjacks, and hotcakes. A cornmeal griddle cake is a pancake made with cornmeal, and the end result is hearty without being heavy. While I usually appreciate a good deal of maple syrup on my pancakes, I tend to load up my cornmeal cakes with heaps of fresh butter. It’s like a fresh, hot, buttery, flat, crunchy corn muffin.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("YIELD: 10 TO 12 LARGE OR 20 SMALL CAKES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "rec-ingredient"
  }, [_c('strong', [_c('em', [_vm._v("Ingredients")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1¼ cups all-purpose flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ teaspoon salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 tablespoon baking powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ teaspoon baking soda")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 cup yellow cornmeal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 tablespoons firmly packed light brown sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 large eggs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 cup buttermilk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 tablespoons unsalted butter, melted")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("4 to 6 tablespoons unsalted butter for the skillet")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "baked"
  }, [_c('strong', [_c('em', [_vm._v("Baked Note")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "imageheight",
    attrs: {
      "id": "ch01lev12"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0053-01.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "h3cap",
    attrs: {
      "id": "zch01lev12"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('strong', [_vm._v("MALTED WAFFLES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("I ARRIVED VERY LATE TO THE WAFFLE PARTY.")]), _vm._v(" I suppose I had a difficult time justifying getting yet another piece of kitchen equipment (both in terms of cost and its occupation of precious kitchen storage space), and I figured my pancakes were so good no one would ever miss a waffle. I was wrong. Friends, fans, and acquaintances peppered me with waffle recipe suggestions. One Baked fan is purported to own at least six waffle irons (I hope his kitchen is larger than mine). I finally gave in and bought a basic and inexpensive waffle iron. It is not fancy, and it is not a vaunted piece of vintage cooking equipment, but it really does the trick.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("YIELD: MAKES ABOUT 10 WAFFLES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "rec-ingredient"
  }, [_c('strong', [_c('em', [_vm._v("Ingredients")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 cups all-purpose flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 cup malt powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 tablespoon firmly packed light brown sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon baking soda")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1½ teaspoons baking powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ teaspoon salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 large eggs, at room temperature")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2½ cups buttermilk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("6 tablespoons (¾ stick) unsalted butter, melted and cooled to room temperature")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("Maple syrup, butter and / or chocolate chips for serving")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "baked"
  }, [_c('strong', [_c('em', [_vm._v("Baked Note")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "imageheight",
    attrs: {
      "id": "ch01lev13"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0055-01.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "h3cap",
    attrs: {
      "id": "zch01lev13"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('strong', [_vm._v("BAKED FRENCH TOAST")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("I WISH I COULD SAY IT IS MY DEEP LOVE OF COMFORT FOOD (MAC AND CHEESE, ALL MANNER OF GRATINS, AND BAKED CHICKEN DISHES) THAT HAS ME ENTRENCHED FIRMLY IN A CASSEROLE PHASE, BUT I FEAR IT IS JUST A GRADUAL DESCENT INTO LAZINESS.")]), _vm._v(" I find them much easier to serve or transport to a gathering. This baked version of French toast is emblematic of this new stage in my life. It is hearty, easy—you put it together the night before your breakfast gathering—delicious, and simple to manipulate (you can swap out fruits and nuts at will).")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("YIELD: ONE 8-INCH SQUARE CASSEROLE (ABOUT 4 SERVINGS)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "rec-ingredient"
  }, [_c('strong', [_c('em', [_vm._v("Ingredients")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cooka",
    attrs: {
      "id": "rrlink13"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#sslink13"
    }
  }, [_vm._v("FOR THE BAKED FRENCH TOAST")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 loaf French, Italian or Challah bread, about 11 ounces")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("5 large eggs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 cup half-and-half")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ cup whole milk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon pure vanilla extract")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¼ teaspoon cinnamon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ cup whole skinned almonds, coarsely chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cooka",
    attrs: {
      "id": "rrlink14"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#sslink14"
    }
  }, [_vm._v("FOR THE RASPBERRY SAUCE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 cup fresh raspberries")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 tablespoons sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon fresh lemon juice or raspberry liqueur")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "sslink13"
    }
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#rrlink13"
    }
  }, [_vm._v("MAKE THE BAKED FRENCH TOAST")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "sslink14"
    }
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#rrlink14"
    }
  }, [_vm._v("MAKE THE RASPBERRY SAUCE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("ASSEMBLE THE FRENCH TOAST")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "baked"
  }, [_c('strong', [_c('em', [_vm._v("Baked Note")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "imageheight",
    attrs: {
      "id": "ch01lev14"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0057-01.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "h3cap",
    attrs: {
      "id": "zch01lev14"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('strong', [_vm._v("DOUBLE-CHOCOLATE LOAF "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WITH PEANUT BUTTER CREAM CHEESE SPREAD")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("I HAVE BEEN TOUTING THE CHOCOLATE-AS-BREAKFAST PHILOSOPHY FOR SOME TIME NOW.")]), _vm._v(" I am neither a medical doctor nor a nutritionist, but I wholeheartedly believe that a few bites of chocolate throughout the day will save you from an all-out midnight binge (the kind where you devour a pint of ice cream and black out). Though this philosophy has not been tested under the supervision of a scientist, I can assure you that the Double-Chocolate Loaf is a great way to start your own experimentation. It is extremely easy to make—it is a quick bread, after all—and the chocolate flavor is intense without being too sweet. Slice and eat it plain, or toast and spread it with a bit of butter, cream cheese, or our recommended spread: Peanut Butter Cream Cheese. It is wonderful with coffee and the morning newspaper.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("YIELD: ONE 9-BY-5-INCH LOAF")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "rec-ingredient"
  }, [_c('strong', [_c('em', [_vm._v("Ingredients")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cooka",
    attrs: {
      "id": "rrlink15"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#sslink15"
    }
  }, [_vm._v("FOR THE DOUBLE-CHOCOLATE LOAF")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¾ cup firmly packed dark brown sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 cup dark unsweetened cocoa powder, (like Valrhona), sifted")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1½ cups all-purpose flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¼ cup granulated sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1½ teaspoons baking soda")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¾ teaspoon baking powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 large eggs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 large egg yolk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("¾ cup buttermilk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("½ cup vegetable oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("1 teaspoon pure vanilla extract")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("8 ounces good-quality dark chocolate (60 to 72%), coarsely chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cooka",
    attrs: {
      "id": "rrlink16"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#sslink16"
    }
  }, [_vm._v("FOR THE CREAM CHEESE SPREAD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("5 ounces cream cheese, softened")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_vm._v("2 tablespoons creamy peanut butter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('em', [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅓")]), _vm._v(" cup sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "sslink15"
    }
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#rrlink15"
    }
  }, [_vm._v("MAKE THE DOUBLE CHOCOLATE LOAF")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _vm._v("Let the cake cool in the pan for 15 minutes, then turn it out onto a wire rack to cool completely.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "sslink16"
    }
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#rrlink16"
    }
  }, [_vm._v("MAKE THE PEANUT BUTTER SPREAD")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "baked"
  }, [_c('strong', [_c('em', [_vm._v("Baked Note")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cook"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sidebartitle"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0053-02.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/3.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/4.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0060-01.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c62556b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 78
// module chunks = 0